import React, { useEffect, useState } from 'react';
import raggera from './img/raggera.png';


function Raggera() {
    const [offset, setOffset] = useState(null);
    const setScroll = () => {
        setOffset(window.scrollY !== 0);
    };
    useEffect(() => {
        window.addEventListener("scroll", setScroll);
        return () => {
            window.removeEventListener("scroll", setScroll);
        };
    }, []);
    return (
        <img src={raggera} alt="" className="position-absolute noprintable" style={{
            width: '28rem',
            zIndex: 100,
            right: '0rem',
            top: '-16rem',
            opacity: !offset ? 1 : 0,
            transition: 'opacity .3s'
        }} />
    );
}

export default Raggera;